export default __webpack_public_path__ + "static/media/ct3.2.477e6121.png";